import productFundCreateRequest from 'request/stylist-booking/booking-studio-product-fund-create'
import productFundCancelRequest from 'request/stylist-booking/booking-studio-product-fund-cancel'

export default function BookingStudioProductFund() {
  const { state, mutate } = useStatic({
    visible: false,
    bookingId: null,
    productFundLog: null,
    callback: null
  })

  h.openBookingStudioProductFund = async(bookingId, productFundLog, callback) => {
    state.bookingId = bookingId
    state.productFundLog = productFundLog
    state.callback = callback
    state.visible = true
    mutate()
  }

  return (
    <C.Modal
      visible={ state.visible }
      close={ () => mutate({ visible: false }) }
      noPadding
    >
      {state.visible && <Body state={ state } mutate={ mutate } />}
    </C.Modal>
  )
}

const Body = parent => {
  const { isAdmin } = useCurrent()
  const { bookingId, productFundLog, callback } = parent.state
  const form = useForm({
    amount: { rule: 'required', value: productFundLog?.studioPricing || '0' },
    note: { value: productFundLog?.note || '' }
  })

  const closePanel = () => {
    parent.state.visible = false
    parent.mutate()
  }

  const onSubmit = async() => {
    await productFundCreateRequest({ bookingId, amount: form.amount.value, note: form.note.value })
    $alert('登錄成功!')
    closePanel()
    if (callback) callback()
  }

  const onDelete = async() => {
    if (!confirm('確定要刪除嗎?')) return
    await productFundCancelRequest({ bookingId })
    $alert('刪除成功!')
    closePanel()
    if (callback) callback()
  }

  const renderProductFund = () => {
    if (!productFundLog) return (
      <div className='flex items-start py-5 font-medium'>
        <div className='w-[6rem]'>耗材費分擔</div>
        <div className='flex items-center flex-1'>
          {Math.round(form.amount.value * 0.1).currency()}
        </div>
      </div>
    )

    return (
      <div className='flex items-start py-5 text-gray-600 font-medium'>
        <div className='w-[6rem]'>耗材費分擔</div>
        <div className='flex items-center flex-1'>
          {productFundLog.fund.currency()}
        </div>
      </div>
    )
  }

  const renderButton = () => {
    if (!productFundLog) return (
      <C.Button
        uid='studioProductFund.submit'
        check={ form }
        onClick={ onSubmit }
        fullWidth
      >
        確認送出
      </C.Button>
    )
    if (!isAdmin) return
    return (
      <C.Button
        uid='studioProductFund.delete'
        variant='outlined'
        onClick={ onDelete }
        className='text-red-500'
        fullWidth
      >
        刪除
      </C.Button>
    )
  }

  return (
    <C.ModalHeader title='耗材費登錄' >
      <div className='flex-1 overflow-scroll p-5 flex flex-col'>
        <C.InputForm
          label='對應店內收費'
          variant='standard'
          form={ form }
          field='amount'
          fullWidth
          number
          disabled={ !!productFundLog }
        />
        <C.InputForm
          label='備註'
          variant='standard'
          form={ form }
          field='note'
          fullWidth
          multiline
          disabled={ !!productFundLog }
        />
        {renderProductFund()}
      </div>
      <div className='relative'><C.Blur /></div>
      <div className='shrink-0 p-5'>
        {renderButton()}
      </div>
    </C.ModalHeader>
  )
}
